import AuthService from "../../utilities/services/auth.service";

import { ModalProvider } from "../../providers/ModalProvider/ModalProvider";

import { PaymentMethodTypeReportWrapper } from "../../components";

export default function PaymentMethodTypeReportPage() {
  const organization = AuthService.getOrg()[0];

  return (
    <ModalProvider>
      <PaymentMethodTypeReportWrapper organization={organization} />
    </ModalProvider>
  );
}
